import request from '@/utils/axios'

const urlGetTransform = function (baseurl, payload) {
  var url = baseurl
  url += '?limit=' + (payload.limit !== undefined ? payload.limit : '10')
  url += '&page=' + payload.page
  // url += '&start_date=' + payload.range.start
  // url += '&end_date=' + payload.range.end
  url += '&filter_target=' + payload.filter.target
  url += '&filter_sort=' + payload.filter.sort
  if (payload.query_tag !== undefined && payload.query_value !== undefined) {
    url += '&query_tag=' + payload.query_tag
    url += '&query_value=' + payload.query_value
  }
  return url
}

export default {
  createInit: ({ commit }) => {
    commit('SET_ARTICLE_GROUP_STATE', true)
  },
  setHomeDataExpiry: ({ commit }, { datetime }) => {
    commit('SET_HOME_ARTICLE_GROUP_EXPIRY', datetime)
  },
  getHomeArticleGroups: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_GROUP_STATE', false)
      var url = '/v1/client/article-group/home'
      request().get(url)
        .then((result) => {
          commit('SET_HOME_ARTICLE_GROUPS', result.data)
          resolve(result.data)
          commit('SET_HOME_ARTICLE_GROUP_STATE', true)
        })
        .catch((err) => {
          console.log(err)
          reject(err)
          commit('SET_ARTICLE_GROUP_STATE', true)
        })
    })
  },
  findArticleGroupByTitle: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_GROUP_STATE', false)
      request().get(`/v1/client/article-group/find-by-title/${data.article_title}`)
        .then((result) => {
          commit('SET_ARTICLE_GROUP', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_GROUP_STATE', true)
        })
        .catch((err) => {
          console.log(err)
          reject(err)
          commit('SET_ARTICLE_GROUP_STATE', true)
        })
    })
  },
  getArticleGroupsByWritter: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit('SET_ARTICLE_GROUP_STATE', false)
      var url = urlGetTransform('/v1/client/article-group/find-by-writter/', data)
      request().get(url)
        .then((result) => {
          commit('SET_ARTICLE_GROUPS', result.data)
          resolve(result.data)
          commit('SET_ARTICLE_GROUP_STATE', true)
        })
        .catch((err) => {
          console.log(err)
          reject(err)
          commit('SET_ARTICLE_GROUP_STATE', true)
        })
    })
  }
}
